import {
  navigationContainer,
  StateId,
  locationContainer,
  getRouterLocationQuery,
} from '@wallaby-ui/core';
import {isArray, isObject} from 'lodash';
import {filterAndSearchSlice} from 'src/js/containers/filter_and_search/filter_and_search_slice';
import {changeQueryParams} from 'src/js/containers/filter_and_search/filter_and_search_thunks';
import {
  GRID_SORT_MODEL_SORT_COLUMN,
  GRID_SORT_MODEL_SORT_DIRECTION,
} from 'src/js/containers/grid/grid_constants';
import {GridPagination, gridSlice} from 'src/js/containers/grid/grid_slice';
import {AppThunk} from 'src/js/store';

import {DEFAULT_LIST_PAGE_SIZE} from './list_constants';
import {listSlice} from './list_slice';
import {getGridStateId} from '../grid';

export function loadStateFromParams(
  stateId: StateId,
  filterAndSearchStateId: StateId,
  defaultPagination?: GridPagination,
  gridId?: StateId,
  paramsPrefix?: string
): AppThunk {
  return (dispatch, getState) => {
    const state = getState();

    const defaultSize = defaultPagination?.pageSize ?? DEFAULT_LIST_PAGE_SIZE;

    const routeParams = getRouterLocationQuery(state);

    const {page, size, sort, memorizedColumnStates} =
      locationContainer.decodeApiParameters(routeParams, paramsPrefix);

    const newMemorizedColumnStates =
      memorizedColumnStates && !isObject(memorizedColumnStates)
        ? JSON.parse(memorizedColumnStates)
        : memorizedColumnStates;

    const newPage = page && !isArray(page) ? parseInt(page, 10) : 1;
    const newSize = size && !isArray(size) ? parseInt(size, 10) : defaultSize;
    let newSort;
    if (sort && !isArray(sort)) {
      if (sort.includes('&')) {
        const splitSortByAnd = sort.split('&');

        splitSortByAnd.map((item) => {
          const sortSplit = item.split(',');
          const newSortModel = [
            {
              [GRID_SORT_MODEL_SORT_COLUMN]: sortSplit[0],
              [GRID_SORT_MODEL_SORT_DIRECTION]: sortSplit[1],
            },
          ];

          newSort = newSort ? newSort?.concat(newSortModel) : newSortModel;
          return null;
        });
      } else {
        const sortSplit = sort.split(',');
        newSort = [
          {
            [GRID_SORT_MODEL_SORT_COLUMN]: sortSplit[0],
            [GRID_SORT_MODEL_SORT_DIRECTION]: sortSplit[1],
          },
        ];
      }
    }

    const gridStateId = gridId ? getGridStateId(gridId) : undefined;

    const promises = [
      dispatch(
        changeQueryParams(
          filterAndSearchStateId,
          {
            page: newPage,
            size: newSize,
            sort: newSort,
          },
          paramsPrefix
        )
      ),
      // if sort is defined, init sort model in grid params
      ...(newPage && newSize && gridStateId
        ? [
            dispatch(
              gridSlice.actions.changeGridParams(gridStateId, {
                params: {
                  pagination: {page: newPage, pageSize: newSize},
                },
              })
            ),
          ]
        : []),
      ...(newSort && gridStateId
        ? [
            dispatch(
              gridSlice.actions.changeGridParams(gridStateId, {
                params: {sort: newSort},
              })
            ),
          ]
        : []),
      ...(newMemorizedColumnStates && gridStateId
        ? [
            dispatch(
              gridSlice.actions.memorizeColumnStates(
                gridStateId,
                newMemorizedColumnStates
              )
            ),
          ]
        : []),
      dispatch(
        filterAndSearchSlice.actions.toggleLoaded(filterAndSearchStateId, {
          list: false,
        })
      ),
    ];

    Promise.all(promises).then(() =>
      Promise.all([
        dispatch(listSlice.actions.locationParsed(stateId, true)),
        dispatch(listSlice.actions.resetReload(stateId)),
      ]).then(() =>
        dispatch(
          filterAndSearchSlice.actions.toggleLoaded(filterAndSearchStateId, {
            list: true,
          })
        )
      )
    );
  };
}
